import {
  ChatRequest,
  ChatResponse,
  MemoryData,
  StatusData,
  WriteResponse,
} from '../types';

import { REMME_API_URL } from '../config';

const API_BASE = REMME_API_URL;

function getSessionId(): string {
  let sid = localStorage.getItem('remme_session_id');
  if (!sid) {
    sid = crypto.randomUUID?.() || `sess-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    localStorage.setItem('remme_session_id', sid);
  }
  return sid;
}

async function apiFetch<T>(path: string, options?: RequestInit): Promise<T> {
  const url = `${API_BASE}${path}`;
  const res = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options?.headers || {}),
    },
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`API error ${res.status}: ${text}`);
  }
  return res.json();
}

export async function sendChat(req: ChatRequest): Promise<ChatResponse> {
  const sessionId = req.sessionId || getSessionId();
  return apiFetch<ChatResponse>('/chat', {
    method: 'POST',
    body: JSON.stringify({ ...req, sessionId }),
  });
}

export async function getMemory(sessionId?: string): Promise<MemoryData> {
  const sid = sessionId || getSessionId();
  return apiFetch<MemoryData>(`/memory?sessionId=${encodeURIComponent(sid)}`);
}

export async function saveMemory(content: string, sessionId?: string): Promise<void> {
  const sid = sessionId || getSessionId();
  await apiFetch('/memory', {
    method: 'POST',
    body: JSON.stringify({ content, sessionId: sid }),
  });
}

export async function getStatus(sessionId?: string): Promise<StatusData> {
  // Worker /status requires sessionId (WS-G fix: was 400 Bad Request without it)
  const sid = sessionId || getSessionId();
  return apiFetch<StatusData>(`/status?sessionId=${encodeURIComponent(sid)}`);
}

export async function submitDraft(
  draft: string,
  type: string,
  sessionId?: string
): Promise<WriteResponse> {
  const sid = sessionId || getSessionId();
  return apiFetch<WriteResponse>('/write', {
    method: 'POST',
    body: JSON.stringify({ draft, type, sessionId: sid }),
  });
}
